<div class="modal-header">
  <h4 class="modal-title">
    {{ 'SALES.SALES_GUEST_NAMES_FORM.FORM_TITLE' | translate }}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
</div>

<form *ngIf="form" id="sale-finals-guest-names-form" [formGroup]="form" (ngSubmit)="save()" novalidate class="modal-body">
  <div class="table-responsive guest-names-table-holder" *ngIf="items.length > 0">
    <table class="table table-bordered guest-names-table">
      <thead>
        <tr>
          <th class="number-column">{{ 'SALES.SALES_GUEST_NAMES_FORM.TABLE_NUMBER_COLUMN_TITLE' | translate }}</th>
          <th class="confirmation-column">
            {{ 'SALES.SALES_GUEST_NAMES_FORM.HOTEL_BOOKING_ROOM_CONFIRMATION_NUMBER' | translate }}
          </th>
          <th>{{ 'SALES.SALES_GUEST_NAMES_FORM.HOTEL' | translate }}</th>
          <th>{{ 'SALES.SALES_GUEST_NAMES_FORM.TYPE' | translate }}</th>
          <th>{{ 'SALES.SALES_GUEST_NAMES_FORM.MEAL_PLAN_SHORT' | translate }}</th>
          <th>{{ 'SALES.SALES_GUEST_NAMES_FORM.CHECK_IN' | translate }}</th>
          <th>{{ 'SALES.SALES_GUEST_NAMES_FORM.NIGHTS' | translate }}</th>
          <th>{{ 'SALES.SALES_GUEST_NAMES_FORM.CHECK_OUT' | translate }}</th>
          <th>{{ 'SALES.SALES_GUEST_NAMES_FORM.PEOPLE' | translate }}</th>
        </tr>
      </thead>

      <tbody formArrayName="items">
        <ng-container *ngFor="let itemGroup of itemGroups.controls; let I = index" [formGroupName]="I">
          <tr class="summary-row">
            <td class="number-column">{{ I + 1 }}</td>
            <td class="confirmation-column">
              <input
                type="text"
                class="form-control"
                [readonly]="items[I]?.confirmationNumberDisabled"
                formControlName="hotel_booking_room_confirmation_number"
              />
            </td>
            <td>
              {{ items[I]?.booking?.hotel?.name }}
              <span *ngIf="items[I]?.booking?.hotel?.stars" class="text-nowrap">
                ({{ items[I]?.booking?.hotel?.stars }} <span class="star-ico-wrapper"><i class="fas fa-star"></i></span>)
              </span>
            </td>
            <td>{{ items[I]?.room?.type?.value }}</td>
            <td>{{ items[I]?.room?.meal_plan?.value }}</td>
            <td>{{ items[I]?.sale_final_item?.check_in | date : env.pipeDateFormat }}</td>
            <td>{{ items[I]?.nights?.length }}</td>
            <td>{{ items[I]?.sale_final_item?.check_out | date : env.pipeDateFormat }}</td>
            <td>{{ items[I]?.peoplePerRoom }}</td>
          </tr>

          <tr class="nights-row">
            <td colspan="9" class="p-0">
              <table class="table table-sm table-borderless nights-table mb-0" formArrayName="nights">
                <tbody>
                  <tr *ngFor="let nightGroup of getNights(itemGroup).controls; let N = index" [formGroupName]="N">
                    <td class="night-date-column">
                      {{ items[I]?.nights?.[N]?.date | date : env.pipeDateFormat }}
                    </td>

                    <td class="request-guest-names-column">
                      <div class="fw-bold">{{ 'SALES.SALES_GUEST_NAMES_FORM.REQUEST_GUEST_NAMES' | translate }}</div>
                      <div *ngIf="items[I]?.peoplePerRoom === 0">
                        {{ 'SALES.SALES_GUEST_NAMES_FORM.NO_GUEST_NAMES_MSG' | translate }}
                      </div>
                      <div *ngFor="let requestName of items[I]?.nights?.[N]?.requestGuestNames">
                        {{ requestName || '—' }}
                      </div>
                    </td>

                    <td class="final-guest-names-column" formArrayName="guest_names">
                      <div style="text-align:left" class="fw-bold">{{ 'SALES.SALES_GUEST_NAMES_FORM.FINAL_GUEST_NAMES' | translate }}</div>
                      <div class="row">
                        <div class="col-sm-4" *ngFor="let guestName of getGuestNames(nightGroup).controls; let J = index">
                          <input type="text" class="form-control" [formControlName]="J" />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div *ngIf="!loading && items.length === 0" class="alert alert-warning mb-0">
    {{ 'SALES.SALES_GUEST_NAMES_FORM.NO_ITEMS_MSG' | translate }}
  </div>
</form>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="modal.dismiss('Cancel')">
    {{ 'CANCEL' | translate }}
  </button>

  <button type="submit" class="btn btn-primary" form="sale-finals-guest-names-form" [disabled]="items.length === 0">
    {{ 'SALES.SALES_GUEST_NAMES_FORM.SAVE' | translate }}
  </button>
</div>
